"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.HRLine = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-top: 1px solid ", ";\n    padding: 1px;\n    flex: 1;\n    margin: ", " 0px;\n"], ["\n    border-top: 1px solid ", ";\n    padding: 1px;\n    flex: 1;\n    margin: ", " 0px;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.border.default;
}, function (_a) {
  var theme = _a.theme;
  return theme.component.margin;
});
exports.HRLabel = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-family: ", ";\n    margin: ", "px ", ";\n"], ["\n    font-family: ", ";\n    margin: ", "px ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.fontText;
}, function (_a) {
  var theme = _a.theme;
  return theme.x / 2;
}, function (_a) {
  var theme = _a.theme;
  return theme.component.margin;
});
var templateObject_1, templateObject_2;